import React from "react";
import "../../scss/layout/form.scss";
const BusinessForm = () => {
  return (
    <div className="form-container">
      <h2>Let's do Business!</h2>
      <form>
        <div className="form-group">
          <select className="input-box">
            <option>Mr.</option>
            <option>Ms.</option>
            <option>Mrs.</option>
          </select>
          <input type="text" placeholder="FIRST NAME" className="input-box" />
          <input type="text" placeholder="LAST NAME" className="input-box" />
        </div>
        <div className="form-group">
          <select className="input-box">
            <option>Phone Prefix</option>
            <option>+1</option>
            <option>+92</option>
            <option>+44</option>
          </select>
          <input type="text" placeholder="PHONE NUMBER" className="input-box" />
        </div>
        <input
          type="email"
          placeholder="E-MAIL ADDRESS"
          className="input-box full-width"
        />
        {/* <div className="buttons">
          <button type="button" className="btn back">
            BACK
          </button>
          <button type="submit" className="btn next">
            NEXT STEP
          </button>
        </div> */}
      </form>
    </div>
  );
};

export default BusinessForm;
